import { styled } from '@mui/material/styles';

export const OverlayRoot = styled('div')(({ theme }) => ({
  position: 'absolute',
  inset: '0 0 0 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
}));
